module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/218-turkey-fffc3d6d71e7f0e785747ac80c65eaaf.svg";